import React, { useState } from 'react'
import Input from '../../Input/Input'

import "./styles.scss"
import Button from '../../Button'
import Select from '../../Input/Select'
import SelectField from './SelectField'
import ResourceFields from '../../ResourceFields'

export default function ResourceField({
    index,
    label,
    name,
    type,
    data,
    setData,
    newFieldButtonText = "Novo campo",

    onDragStart,
    onDragEnd

}) {
    const setValue = (key, value) => {
        setData(data => {
            data.fields[index][key] = value

            if (value == "select" && (!data.fields[index].options || data.fields[index].options.length == 0)) {
                data.fields[index].options = [
                    {
                        name: "",
                        value: ""
                    }
                ]
            }

            if (value == "object-list" && (!data.fields[index].fields || data.fields[index].fields.length == 0)) {
                data.fields[index].fields = [
                    {
                        label: "",
                        name: "",
                        type: ""
                    }
                ]
            }

            return { ...data }
        })
    }

    const remove = () => {
        setData(data => {
            data.fields.splice(index, 1);

            return { ...data }
        })
    }

    const handleAddOption = () => {
        setData(data => {
            data.fields[index].options.push([
                {
                    name: "",
                    value: ""
                }
            ])

            return { ...data }
        })
    }

    return (
        <div className="resource-field">
            {data.fields.length > 1 &&
                <div className="flutuant-bottons">
                    <div
                        draggable
                        onDragStart={onDragStart}
                        onDragEnd={onDragEnd}
                    >
                        <Button
                            variant={"ghost"}
                            icon="order-elements"
                            onClick={remove}
                        />
                    </div>

                    <Button
                        variant={"delete"}
                        icon="trash"
                        onClick={remove}
                    />
                </div>
            }

            <div>
                <Input
                    name="label"
                    label="Título"
                    placeholder="Título do campo"
                    value={data.fields[index].label}
                    onChange={e => setValue("label", e.target.value)}
                    waitTime={50}
                />
            </div>
            <div className="flex" style={{ gap: 10 }}>
                <div style={{ flex: 1 }}>
                    <Input
                        name="name"
                        label="Chave"
                        placeholder="Chave do campo"
                        value={data.fields[index].name}
                        onChange={e => setValue("name", e.target.value)}
                        waitTime={50}
                    />
                </div>
                <div style={{ flex: 1 }}>
                    <Select
                        label="Tipo"
                        options={[
                            { text: "Texto", value: "text" },
                            { text: "Seleção", value: "select" },
                            { text: "Lista de texto", value: "text-list" },
                            // { text: "Lista de textos", value: "text-list" },
                            { text: "Lista de objetos", value: "object-list" },
                            { text: "On/Off", value: "switch" },
                            { text: "Arquivo", value: "file" },
                        ]}
                        value={data.fields[index].type}
                        onChange={e => setValue("type", e.target.value)}
                    />
                </div>
            </div>

            {data.fields[index].type == "select" &&
                <div>
                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                        <bds-typo variant="fs-16" tag="h2" translate="" className="hydrated">Opções</bds-typo>

                        <Button
                            variant={"primary"}
                            text="Nova opção"
                            onClick={handleAddOption}
                            size="short"
                        />
                    </div>

                    <div className="mt2 options">
                        {/* {JSON.stringify(data.fields[index]?.options)} */}
                        {data.fields[index]?.options?.map((option, indexOption) =>
                            <SelectField
                                key={`indexOption-${indexOption}`}
                                data={data}
                                setData={setData}
                                indexField={index}
                                indexOption={indexOption}
                                totalSize={data.fields[index]?.options.length}
                            />
                        )}
                    </div>
                </div>
            }

            {data.fields[index].type == "object-list" &&
                <div>
                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                        <bds-typo variant="fs-16" tag="h2" translate="" className="hydrated">Campos do objeto</bds-typo>

                        <Button
                            variant={"primary"}
                            text={newFieldButtonText}
                            onClick={() => {
                                setData(data => {
                                    data.fields[index].fields.push([
                                        {
                                            name: "",
                                            value: ""
                                        }
                                    ])

                                    return { ...data }
                                })
                            }}
                            size="short"
                        />
                    </div>

                    <div className="mt2 options">
                        {/* {JSON.stringify(data.fields[index])} */}
                        <ResourceFields
                            data={data.fields[index]}
                            setData={data2 => {
                                console.log(data2)
                                setData(data => {
                                    let data2Value = data2({ ...data.fields[index] })

                                    data.fields[index] = { ...data2Value }

                                    for (let i = 0; i < data.fields[index].fields.length; i++) {
                                        data.fields[index].fields[i] = {
                                            ...data.fields[index].fields[i]
                                        }
                                    }

                                    return JSON.parse(JSON.stringify(data))
                                })
                            }}
                            newFieldButtonText="Novo campo do objeto"
                        />
                    </div>
                </div>
            }
        </div>
    )
}